import { isValidId, toIdString } from './ids.js';

export function toProductId(item) {
  const value = item?.ProductId ?? item?.productId ?? item?.itemId ?? item?.id;
  const id = toIdString(value);
  return isValidId(id) ? id : null;
}

export function toQuantity(item) {
  const quantity = Number(item?.Quantity ?? item?.quantity ?? 1);
  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
}

export function recalculateCartItem(item) {
  const price = Number(item?.Price ?? item?.price ?? 0);
  const quantity = toQuantity(item);
  return {
    ...item,
    ProductId: toProductId(item),
    Quantity: quantity,
    Price: price,
    Total: price * quantity,
  };
}

export function mergeCartItems(primary = [], incoming = []) {
  const byProduct = new Map();

  [...primary, ...incoming].forEach((item) => {
    const productId = toProductId(item);
    if (!productId) return;

    const normalized = recalculateCartItem({ ...item, ProductId: productId });
    const existing = byProduct.get(productId);
    if (!existing) {
      byProduct.set(productId, normalized);
      return;
    }

    const quantity = toQuantity(existing) + toQuantity(normalized);
    const price = Number(normalized.Price || existing.Price || 0);
    byProduct.set(productId, {
      ...existing,
      ...normalized,
      ProductId: productId,
      Quantity: quantity,
      Price: price,
      Total: price * quantity,
    });
  });

  return Array.from(byProduct.values());
}

export function toCartRequestItems(cartItems = []) {
  return (cartItems || [])
    .map((item) => ({
      itemId: toProductId(item),
      quantity: toQuantity(item),
    }))
    .filter((item) => isValidId(item.itemId) && item.quantity > 0);
}